'use client'

import { motion } from 'framer-motion'
import { ProjectCategory } from '@/lib/projects-data'

interface ProjectFilterProps {
  activeCategory: ProjectCategory
  onCategoryChange: (category: ProjectCategory) => void
}

const categories: ProjectCategory[] = ['All', 'AI', 'SaaS', 'MVP', 'Enterprise']

export function ProjectFilter({ activeCategory, onCategoryChange }: ProjectFilterProps) {
  return (
    <div className="flex flex-wrap gap-2 justify-center">
      {categories.map((category) => (
        <motion.div
          key={category}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <button
            onClick={() => onCategoryChange(category)}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
              activeCategory === category
                ? 'bg-gray-900 text-white shadow-md'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            {category}
          </button>
        </motion.div>
      ))}
    </div>
  )
}

